import { FETCHED_TOKEN_VERIFICATION,
  FETCHING_TOKEN_VERIFICATION } from './verifyEmailAddressContainerActions'

const initialState = {
  loading: true,
  token: null,
  verifiedEmailAddress: ''
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCHING_TOKEN_VERIFICATION:
      return initialState
    case FETCHED_TOKEN_VERIFICATION:
      return {
        loading: false,
        verifiedEmailAddress: action.payload.verifiedEmailAddress,
        adviserName: action.payload.adviserName,
        adviserId: action.payload.adviserId
      }
  }
  return state
}
